// see https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_InitiateAuth.html#API_InitiateAuth_Errors

const ERRORS = [
  {
    code: 'InternalErrorException',
    msg: 'Interner AWS Cognito Fehler.',
  },
  {
    code: 'InvalidLambdaResponseException',
    msg: 'Interner AWS Lambda Fehler.',
  },
  {
    code: 'InvalidParameterException',
    msg: 'Ungültiger Parameter.',
    msgSubErrors: [
      {
        key: 'userName',
        msg: 'Die eingegebene E-Mail-Adresse ist nicht gültig.',
      },
      {
        key: 'userAlias',
        msg: 'Das eingegebene Passwort ist nicht gültig.',
      },
    ],
  },
  {
    code: 'InvalidSmsRoleAccessPolicyException',
    msg: 'Die Rolle zur SMS Konfiguration hat unzureichende AWS SNS Berechtigungen.',
  },
  {
    code: 'InvalidSmsRoleTrustRelationshipException',
    msg: 'Die SMS Konfiguration hat eine ungültige Vertrauensstellung.',
  },
  {
    code: 'InvalidUserPoolConfigurationException',
    msg: 'Die AWS Cognito Userpool Konfiguration ist fehlerhaft.',
  },
  {
    code: 'NotAuthorizedException',
    msg: 'Du konntest nicht angemeldet werden.',
    msgSubErrors: [
      {
        key: 'Incorrect username or password.',
        msg: 'Falscher Benutzername oder Passwort.',
      },
      {
        key: 'Password attempts exceeded',
        msg: 'Anzahl der Loginversuche überschritten - bitte versuche es später erneut.',
      },
    ],
  },
  {
    code: 'PasswordResetRequiredException',
    msg: 'Eine Passwortänderung ist erforderlich.',
  },
  {
    code: 'ResourceNotFoundException',
    msg: 'Die Resource wurde nicht gefunden.',
  },
  {
    code: 'TooManyRequestsException',
    msg: 'Deine Aktion hat das zulässige Limit überschritten. Versuche es später erneut.',
  },
  {
    code: 'UnexpectedLambdaException',
    msg: 'Interner AWS Lambda Fehler.',
  },
  {
    code: 'UserLambdaValidationException',
    msg: 'User Validierungsfehler.',
  },
  {
    code: 'UserNotConfirmedException',
    msg: 'Du hast deinen Account noch nicht bestätigt.',
  },
  {
    code: 'UserNotFoundException',
    msg: 'Falscher Benutzername oder Passwort.',
  },
]

export {ERRORS}
